import getInstance from "../config/api";

export default class HashAgency {
  static async fetchTotalHashAgency(params) {
    const instance = getInstance();
    const { data } = await instance.get("/hash-agency/grouped", { params });
    return data;
  }

  static async downloadHashTotalsCSV(params) {
    const instance = getInstance();
    const data = await instance.get("/hash-agency/csv-totals", { params });
    return data;
  }

  static async fetchHashAgency(params) {
    const instance = getInstance();
    const { data } = await instance.get("/hash-agency", { params });
    return data;
  }

  static async downloadHashCSV(params) {
    const instance = getInstance();
    const data = await instance.get("/hash-agency/csv", { params });
    return data;
  }
}
